module.exports = __webpack_public_path__ + "img/j.2cb94a42.jpg";